import {useContext} from 'react';
import { useTranslation } from 'react-i18next';
import { Link } from 'react-router-dom';
import { Context } from '../../index';
import './unauthorized.css';

export default function Unauthorized() {
    const {store} = useContext(Context);
    const { t } = useTranslation();
    return (
        <div className="unauthorized">
            <div className="authRequired">
                <div className="authRequired_title">{t('unauthorized.title')}</div>
                <div className="authRequired_logo_wrapper">
                    <img src="/img/other/auth-required_min.png" alt="" className="authRequired_logo" />
                    <div className="authRequired_logo-loading"></div>
                </div>
            </div>
            <div className="authRequired_subtitle">{t('unauthorized.subtitle')}</div>
            <button className="authRequired_login" onClick={() => store.login()}>{t('unauthorized.login')}</button>
            <Link to='/products' className="authRequired_back">
                <div className="authRequired_back_text">{t('unauthorized.back')}</div>
                <svg fill="none" xmlns="http://www.w3.org/2000/svg" viewBox="0 0 20 20" className="authRequired_linkIcon"><path d="M20 10.101c0 .288-.11.577-.328.75l-3.61 3.52c-.382.404-.983.346-1.366-.058-.383-.404-.328-1.039.055-1.442l2.843-2.77-2.844-2.77c-.382-.404-.437-1.038-.054-1.442.383-.404.984-.462 1.367-.058l3.609 3.52c.219.173.328.462.328.75Z" fill="#ccc"></path><path d="M18.578 10.101c0 .577-.437 1.039-.984 1.039H.984C.437 11.14 0 10.678 0 10.1s.437-1.039.984-1.039h16.61c.547 0 .984.462.984 1.039Z" fill="#BEBFC5"></path></svg>
            </Link>
        </div>
    )
}